<script setup lang="tsx">
import { getCSSVar } from "@zyzgroup/core-web";

const props = withDefaults(
  defineProps<{
    width?: string;
    height?: string;
    color?: string;
  }>(),
  {
    width: "24px",
    color: getCSSVar("--xg-red")
  }
);
</script>

<template>
  <svg
    viewBox="0 0 48 48"
    :width="props.width"
    :height="props.height ?? props.width"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style="transform-origin: center"
  >
    <path
      d="M24 46.5C36.4264 46.5 46.5 36.4264 46.5 24C46.5 11.5736 36.4264 1.5 24 1.5C11.5736 1.5 1.5 11.5736 1.5 24C1.5 36.4264 11.5736 46.5 24 46.5Z"
      :fill="props.color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M26.1514 24L33.3033 16.8481C33.8989 16.2525 33.8989 15.2924 33.3033 14.6967C32.7076 14.1011 31.7475 14.1011 31.1519 14.6967L24 21.8486L16.8481 14.6967C16.2525 14.1011 15.2924 14.1011 14.6967 14.6967C14.1011 15.2924 14.1011 16.2525 14.6967 16.8481L21.8486 24L14.6967 31.1519C14.1011 31.7475 14.1011 32.7076 14.6967 33.3033C15.2924 33.8989 16.2525 33.8989 16.8481 33.3033L24 26.1514L31.1519 33.3033C31.7475 33.8989 32.7076 33.8989 33.3033 33.3033C33.8989 32.7076 33.8989 31.7475 33.3033 31.1519L26.1514 24Z"
      fill="white"
    />
  </svg>
</template>
